import {baseRequestService} from "../../base.ts";

export const usersUserIdContactsContactIdPrimaryPut = (userId: number, contactId: string) =>
    baseRequestService({
        url: `/users/${userId}/contacts/${contactId}/primary`,
        method: 'PUT'
    })